import { stampRequestStart } from '@payments-checkout/shared/observability';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import axios, { type AxiosError } from 'axios';
import { env } from 'next-runtime-env';

// A tokenização usa o `axios` global; instância criada com `axios.create()` não
// herda interceptors do default.
axios.interceptors.request.use(stampRequestStart);

type CardDataProps = {
  type: string;
  card: {
    number: string | undefined;
    holder_name: string | null;
    exp_month: string | undefined;
    exp_year: string | undefined;
    cvv: string | null;
  };
};

export async function sendTokenizeCard(
  publicKey: string,
  cardData: CardDataProps
) {
  const response = await axios.post(
    `${env('NEXT_PUBLIC_MARK1_API') ?? ''}tokens?appId=${publicKey}`,
    { ...cardData }
  );
  return response.data;
}

export const useSendTokenizeCard = (
  options?: Omit<
    UseMutationOptions<
      unknown,
      AxiosError,
      { publicKey: string; cardData: CardDataProps }
    >,
    'mutationFn'
  >
) => {
  return useMutation({
    mutationFn: ({
      publicKey,
      cardData,
    }: {
      publicKey: string;
      cardData: CardDataProps;
    }) => sendTokenizeCard(publicKey, cardData),
    ...options,
  });
};
